
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminosycondiciones",
      function () {
        return require("private-next-pages/terminosycondiciones/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminosycondiciones"])
      });
    }
  